import React, { useEffect, useState } from 'react'
import { checkPassword } from '../pages/apiCall/LoginCall'

const PasswordCheck = ({ password, passwordCheck }) => {

    let lang = localStorage.getItem("lang") !== undefined ? localStorage.getItem("lang") : "tr"
    let passwordRules = [
        "Parola en az 8 karakter uzunluğunda olmalıdır.",
        "Parola en az bir büyük harf içermelidir.",
        "Parola en az bir küçük harf içermelidir.",
        "Parola en az bir rakam içermelidir.",
        "Parola en az bir özel karakter içermelidir."

    ]
    let passwordRulesEng = [
        "Password must be at least 8 characters long.",
        "Password must contain at least one uppercase letter.",
        "Password must contain at least one lowercase letter.",
        "Password must contain at least one number.",
        "Password must contain at least one special character."
    ]
    const [passwordRulesValidate, setPasswordRulesValidate] = useState(
        {
            "Parola en az 8 karakter uzunluğunda olmalıdır.": null,
            "Parola en az bir büyük harf içermelidir.": null,
            "Parola en az bir küçük harf içermelidir.": null,
            "Parola en az bir rakam içermelidir.": null,
            "Parola en az bir özel karakter içermelidir.": null
        }
    )

    useEffect(() => {

        if (password !== undefined) {
            checkPassword(password || "", setPasswordRulesValidate, passwordCheck)
        }
    }, [password, passwordCheck])



    return (
        // <Collapse isOpen={Object.values(passwordRulesValidate).filter((item) => item === true).length > 0 ? true : false}
        // >
        <div className="form-group">
            <ul>
                {passwordRules.map((rule, index) => {
                    return (<li key={index}>
                        {
                            passwordRulesValidate[rule] === null ?
                                <p style={{ padding: "0", margin: "0", color: "gray" }}> {lang === "tr" ? rule : passwordRulesEng[index]}</p>
                                : passwordRulesValidate[rule] === true ?
                                    <p style={{ padding: "0", margin: "0", color: "green" }}> <i className="fa fa-check" style={{ color: "green" }}></i>
                                        {lang === "tr" ? rule : passwordRulesEng[index]}
                                    </p> :
                                    <p style={{ padding: "0", margin: "0", color: "red" }}> <i className="fa fa-times" style={{ color: "red" }}></i> {lang === "tr" ? rule : passwordRulesEng[index]}</p>
                        }
                    </li>)
                })}
            </ul>
        </div>
        // </Collapse>
    )
}

export default PasswordCheck